module.exports = __webpack_public_path__ + "static/img/banner1.64be16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/home/banner1.png
// module id = iQEJ
// module chunks = 2